<template>
  <BaseChart
    height="300px"
    chart-height="200px"
    title="Price development in original currency"
    :chart-data="mergedChartData"
    :subtitle="subtitle"
  >
    <template #widget-options>
      <slot name="widget-options"></slot>
    </template>
  </BaseChart>
</template>

<script>
import { commonPropertiesMixin } from './common-properties-mixin'
import { customChartData } from '@/reusable/base-chart/common-custom-chart-data'

export default {
  mixins: [commonPropertiesMixin('price-development-in-original-currency', customChartData)],

  computed: {
    subtitle() {
      if (!this.supportData) return 'Original currency'
      return `Original currency (${this.supportData.merge_data['[[ CURRENCY ]]']})`
    }
  }
}
</script>
